export default __webpack_public_path__ + "static/media/long-arrow.7b948fb5.svg";